export const GET_COMPOSER_LIST = 'app/Composers/GET_COMPOSER_LIST';
export const GET_COMPOSER_SEARCH_LIST = 'app/Composers/GET_COMPOSER_SEARCH_LIST';
export const CLEAR_COMPOSER_SEARCH_LIST = 'app/Composers/CLEAR_COMPOSER_SEARCH_LIST';
